import { useCallback, useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import generalServices from '@/general/services/services'

const useUserInfo = userInfo => {
  const { fetchData: editUserProfile, loading: applyingUserProfile } = useFetch(generalServices.editUserProfile, {
    doInitialRequest: false,
  })

  const [image, setImage] = useState(null)
  const [name, setName] = useState('')
  const [lastName, setLastName] = useState('')
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [hasChanges, setHasChanges] = useState(false)

  const setInitValues = useCallback(() => {
    if (userInfo) {
      setImage({ file: null, preview: userInfo?.profile_picture_url || null })
      setName(userInfo?.first_name || '')
      setLastName(userInfo?.last_name || '')
      setUsername(userInfo?.username || '')
      setEmail(userInfo?.email || '')
      setHasChanges(false)
    }
  }, [userInfo])

  useEffect(() => {
    setInitValues()
  }, [setInitValues])

  const deleteImage = () => {
    setImage({
      preview: null,
      file: new File([], ''),
    })
    setHasChanges(true)
  }

  const changeImage = file => {
    setImage({
      preview: URL.createObjectURL(file),
      file,
    })
    setHasChanges(true)
  }

  const revertChanges = () => {
    setInitValues()
  }

  return {
    image,
    deleteImage,
    changeImage,
    hasChanges,
    setHasChanges,
    revertChanges,
    name,
    setName: param => {
      setName(param)
      setHasChanges(true)
    },
    lastName,
    setLastName: param => {
      setLastName(param)
      setHasChanges(true)
    },
    username,
    setUsername: param => {
      setUsername(param)
      setHasChanges(true)
    },
    email,
    setEmail: param => {
      setEmail(param)
      setHasChanges(true)
    },
    editUserProfile,
    applyingUserProfile,
  }
}

export default useUserInfo
